
import $ from 'jquery';
const accordion = (() => {
  const defaultAccordion = () => {
    const accordionItem = document.getElementsByClassName('js-trigger-accordion');

    for (let i = 0; i < accordionItem.length; i += 1) {
      accordionItem[i].addEventListener('click', function (event) {
        event.currentTarget.classList.toggle('js-active');
        const accordionContent = this.nextElementSibling;
        event.currentTarget.querySelector('.c-accordion__icon svg').classList.toggle('js-active');
        accordionContent.classList.toggle('js-active');
      });
    }
  };
  const milestonesScroll = () => {
      $(window).scroll(function(){
        $(".milestones-page .list .item").each(function(){
          if ($(window).scrollTop() > $(this).offset().top - 200) {
            $(this).addClass('active');
          } else {
            $(this).removeClass('active');
          }
        });
      });
  };

  const init = () => {
    defaultAccordion();
    milestonesScroll();
  };

  return {
    init,
  };
})();

export default accordion;
